import { Field, Text, Textarea, TextareaProps } from '@chakra-ui/react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';

interface FormTextareaProps extends Omit<TextareaProps, 'name'> {
  name: string;
  label: string;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  helperText?: string;
  rows?: number;
  required?: boolean;
}

const FormTextarea = ({
  name,
  label,
  register,
  errors,
  helperText,
  rows = 3,
  required,
  ...textareaProps
}: FormTextareaProps) => {
  const fieldError = errors[name];
  const isInvalid = !!fieldError;

  return (
    <Field.Root invalid={isInvalid}>
      <Field.Label>
        {label}
        {required && <Text color="red.fg">*</Text>}
      </Field.Label>
      <Textarea rows={rows} {...register(name)} {...textareaProps} minH="32" />
      {helperText && <Field.HelperText>{helperText}</Field.HelperText>}
      {isInvalid && fieldError.message && (
        <Field.ErrorText>
          {typeof fieldError.message === 'string' ? fieldError.message : 'Invalid input'}
        </Field.ErrorText>
      )}
    </Field.Root>
  );
};

export default FormTextarea;
